import React from 'react';
import { sortCaret, headerSortingClasses } from '../../../../helpers';
import { WidgetDate, WidgetTime, WidgetStatus, WidgetLinkTruncatedText } from '../../../../components';
import statuses from '../../../../constants/makeandchecker/statuses';
import { Tooltip, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ClientsWidgets ({ handleClickClientLock, handleClickClientLockReply, handleClickDropClient }) {
    const { t } = useTranslation();
    return [{
        dataField: 'id',
        text: t('management.unsubscription.table.columns.id'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses
    }, {
        dataField: 'created_at',
        text: t('management.unsubscription.table.columns.date'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                <>
                    <WidgetDate date={new Date(cellContent)} />
                    <span> </span>
                    {(cellContent ? <WidgetTime date={new Date(cellContent)} /> : null)}
                </>
            );
        }
    },
    {
        dataField: 'client.formattedName',
        text: t('management.unsubscription.table.columns.client'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/details/${row.client?.id}`} text={cellContent || ''} truncated='false' />)
    }, {
        dataField: 'metadata.user',
        text: t('management.unsubscription.table.columns.managed'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => {
            return (
                <>
                    {cellContent && (
                        <div>{`${cellContent.formattedName}`}</div>
                    )}
                </>
            );
        }
    }, {
        dataField: 'status.description',
        text: t('management.unsubscription.table.columns.status'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetStatus type={statuses[cellContent]?.type} text={`management.unsubscription.table.status.${statuses[cellContent]?.id}`} />)
    }, {
        dataField: 'client.id',
        text: t('management.unsubscription.table.columns.actions'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatExtraData: {
            handleClickClientLock,
            handleClickClientLockReply,
            handleClickDropClient
        },
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row, rowIndex, { handleClickClientLock, handleClickClientLockReply, handleClickDropClient }) => {
            const buttonTitle = row.status.id === statuses.pending.id ? t('buttons.confirm') : t('watch');
            return (
                <>
                    <Tooltip title={<Typography fontSize={10}>{buttonTitle}</Typography>}>
                        <Typography>
                            <Button
                                className='actionButton'
                                onClick={() => handleClickDropClient(row.id)}
                            >
                                {t('management.unsubscription.table.details.title')}
                            </Button>
                        </Typography>
                    </Tooltip>
                </>
            );
        }
    }];
}
